import React from 'react';

/**
 * リリース情報
 */
export default function MusicAlbumInfoReleaseTrackDiscountView({
  musicAlbum,
  music,
} : {
  musicAlbum: {
    id: number,
    release_status: number,
  },
  music: {
    id: number,
    is_inst: number,
  },
}) {
  // 作成中や要修正の場合は表示しない
  if (musicAlbum.release_status === 0 || musicAlbum.release_status === 5) {
    return null;
  }
  // インスト曲の場合はカラオケ配信しない
  if (music.is_inst) {
    return null;
  }

  return (
    <>
      <ul>
        <li className="bt add_karaoke_bt">
          <span className="bt_info">\ 1000円OFFで簡単に /</span>
          <button
            className="submit_bt"
            type="button"
            onClick={() => {
              document.location.href = `/karaoke_orders?music_album_id=${musicAlbum.id}&music_id=${music.id}&coupon_code=musicsv`;
            }}
          >
            この曲をカラオケ配信
          </button>
        </li>
      </ul>
    </>
  );
}
